import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

@Injectable()
export class IncidentListService {
  private base_url = `${environment.API_URL}/offers/`;
  private single_url = `${environment.API_URL}/incidents/`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  getIncidents(planning_id: number) {
    var params = {};
    params["id"] = planning_id;
    //params["token"] = this.token;
    return this.http
      .post(this.base_url + params["id"] + "/incidents", params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  createIncident(params: object) {
    //params["token"] = this.token;
    return this.http
      .post(this.base_url + params["id"] + "/incident", params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Incident ajouté.", false, "Incident");
        } else {
          //console.log(response);
          this.toast.error(
            "Erreur lors de l'ajout de l'incident.",
            false,
            "Incident"
          );
        }
      });
  }

  updateIncident(params: object) {
    //params["token"] = this.token;
    return this.http
      .patch(this.single_url + params["id"], params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Incident Mise à jour.", false, "Incident");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de l'incident",
            false,
            "Incident"
          );
        }
      });
  }

  deleteIncident(incident_id:number) {
    return this.http
      .delete(`${this.single_url}${incident_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Incident Supprimé.", false, "Incident");
        } else {
          this.toast.error(
            "Erreur lors de la suppression de l'incident.",
            false,
            "Incident"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/incident-list.service.ts